(function (window, document, $) {

    $(document).ready(function () {

        'use strict';

        $(document).on( "wpgu-favorite-btn-clicked", function( e, button ) {
            if($(button).hasClass('selected')) {
                // do mojs animation on heart icon
                var id = $(button).data('wpgu-favorite-id');
                window.doHeartAnimation(".video-fav-button-" + id);

                // change text next to heart icon in single-video
                $(".single-video .favorite-text").html("Verwijder uit favorieten");
            } else {
                // if button has been unselected reset text
                $(".single-video .favorite-text").html("Bewaar als favoriet");
            }
        });
    });

}(window, document, jQuery));


// functions for mojs animation        ===============================================================
window.Animocon = function(el, options) {
    this.el = el;
    this.options = window.extend({}, this.options);
    window.extend(this.options, options);

    this.timeline = new mojs.Timeline();

    for (var i = 0, len = this.options.tweens.length; i < len; ++i) {
        this.timeline.add(this.options.tweens[i]);
    }

    this.timeline.replay();
}

window.Animocon.prototype.options = {
    tweens: [
        new mojs.Burst({})
    ]
};

window.extend = function(a, b) {
    for (var key in b) {
        if (b.hasOwnProperty(key)) {
            a[key] = b[key];
        }
    }
    return a;
}

// do heart animation        ===============================================================
window.doHeartAnimation = function(fav_button) {
    if (!fav_button) {
        return;
    }

    var items = document.querySelectorAll(fav_button);

    if (items.length < 1) {
        return;
    }

    for (var i = 0, len = items.length; i < len; ++i) {

        var fav_icon = items[i].querySelector('.icon-heart-regular');
        var tweens = [
            // ring animation
            new mojs.Shape({
                parent: items[i],
                className: 'fav-mojs-shape',
                duration: 750,
                type: 'circle',
                radius: { 0: 40 },
                fill: 'transparent',
                stroke: '#F35186',
                strokeWidth: { 35: 0 },
                opacity: 0.2,
                top: '45%',
                easing: mojs.easing.bezier(0, 1, 0.5, 1)
            }),
            new mojs.Shape({
                parent: items[i],
                className: 'fav-mojs-shape',
                duration: 500,
                delay: 100,
                type: 'circle',
                radius: { 0: 20 },
                fill: 'transparent',
                stroke: '#F35186',
                strokeWidth: { 5: 0 },
                opacity: 0.2,
                x: 40,
                y: -60,
                easing: mojs.easing.sin.out
            }),
            new mojs.Shape({
                parent: items[i],
                className: 'fav-mojs-shape',
                duration: 500,
                delay: 180,
                type: 'circle',
                radius: { 0: 10 },
                fill: 'transparent',
                stroke: '#F35186',
                strokeWidth: { 5: 0 },
                opacity: 0.5,
                x: -10,
                y: -80,
                isRunLess: true,
                easing: mojs.easing.sin.out
            }),
            new mojs.Shape({
                parent: items[i],
                className: 'fav-mojs-shape',
                duration: 800,
                delay: 240,
                type: 'circle',
                radius: { 0: 20 },
                fill: 'transparent',
                stroke: '#F35186',
                strokeWidth: { 5: 0 },
                opacity: 0.3,
                x: -70,
                y: -10,
                easing: mojs.easing.sin.out
            }),
            new mojs.Shape({
                parent: items[i],
                className: 'fav-mojs-shape',
                duration: 800,
                delay: 240,
                type: 'circle',
                radius: { 0: 20 },
                fill: 'transparent',
                stroke: '#F35186',
                strokeWidth: { 5: 0 },
                opacity: 0.4,
                x: 80,
                y: -50,
                easing: mojs.easing.sin.out
            }),
            new mojs.Shape({
                parent: items[i],
                className: 'fav-mojs-shape',
                duration: 1000,
                delay: 300,
                type: 'circle',
                radius: { 0: 15 },
                fill: 'transparent',
                stroke: '#F35186',
                strokeWidth: { 5: 0 },
                opacity: 0.2,
                x: 20,
                y: -100,
                easing: mojs.easing.sin.out
            }),
            new mojs.Shape({
                parent: items[i],
                className: 'fav-mojs-shape',
                duration: 600,
                delay: 330,
                type: 'circle',
                radius: { 0: 25 },
                fill: 'transparent',
                stroke: '#F35186',
                strokeWidth: { 5: 0 },
                opacity: 0.4,
                x: -40,
                y: -90,
                easing: mojs.easing.sin.out
            }),
            // icon scale animation
            new mojs.Tween({
                duration: 1200,
                easing: mojs.easing.ease.out,
                onUpdate: function (progress) {
                    if (progress > 0.3) {
                        var elasticOutProgress = mojs.easing.elastic.out(1.43 * progress - 0.43);
                        fav_icon.style.WebkitTransform = fav_icon.style.transform = 'scale3d(' + elasticOutProgress + ',' + elasticOutProgress + ',1)';
                    }
                    else {
                        fav_icon.style.WebkitTransform = fav_icon.style.transform = 'scale3d(0,0,1)';
                    }
                },
                onComplete: function () {
                    jQuery('.fav-mojs-shape').remove();
                }
            })
        ];

        new window.Animocon(items[i], { tweens: tweens });
    }
}
